import { REFUND_PERCENTAGE_MAP } from '../constants';

export function calculateCashReversed(reason: string, creditDeduction: number): number {
  if (!reason || !creditDeduction || creditDeduction <= 0) {
    return 0;
  }

  const percentage = REFUND_PERCENTAGE_MAP[reason];
  if (percentage != null) {
    return Math.round(creditDeduction * percentage * 100) / 100;
  }

  return creditDeduction;
}
